// extracted by mini-css-extract-plugin
export default {"container":"UnknownRoute_container__GAGov","subtitle":"UnknownRoute_subtitle__G2vm8"};